module.exports = __webpack_public_path__ + "static/media/person2.9d7214d6.jpg";